export default __webpack_public_path__ + "static/media/ViewDetailsArrow.53c29b5a.svg";